/**
 * Bottom-sheet controller (mobile). On desktop the same element is a static
 * sidebar and these class toggles are simply ignored by the CSS.
 */

export interface SheetController {
  expand(): void;
  collapse(): void;
  toggle(): void;
}

export function initSheet(
  panel: HTMLElement,
  handle: HTMLElement,
  scrim: HTMLElement,
): SheetController {
  const setExpanded = (expanded: boolean): void => {
    panel.classList.toggle('is-expanded', expanded);
    handle.setAttribute('aria-expanded', String(expanded));
    scrim.hidden = !expanded;
  };

  const controller: SheetController = {
    expand: () => setExpanded(true),
    collapse: () => setExpanded(false),
    toggle: () => setExpanded(!panel.classList.contains('is-expanded')),
  };

  handle.setAttribute('aria-expanded', 'false');
  handle.addEventListener('click', () => controller.toggle());
  scrim.addEventListener('click', () => controller.collapse());

  return controller;
}
